import Event from '../../../lib/event';
import xtend from 'xtend';
import _ from 'underscore';

var _manifest = {
    eventsQuery: {
        changeSearchKey: _.compose(
            Event('eventsQuery'),
            Event('changeSearchKey')
        ),
        change: _.compose( Event('eventsQuery'), Event('change') )
    },

    vast: {
        edit: _.compose( Event('vast'), Event('edit') ),
        shiftMessage: _.compose( Event('vast'), Event('shiftMessage') )
    }
};

['vast', 'events', 'assets', 'categories'].forEach(function (endpoint) {
    _manifest[endpoint] = xtend(_manifest[endpoint], {
        shiftError: _.compose(Event(endpoint), Event('shiftError'))
    });
});

var manifest = [
    'changeTab',
    'changeScope',
    'editTitle',
    'cancelTitleEdit',
    'assignCategory',
    'unassignCategory',
    'submitQuery',
    'assignCampaignEvent',
    'unassignCampaignEvent',
    'assignAsset',
    'editAsset',
    'removeAsset',
    'changeStartDate',
    'changeEndDate',
    'changeAction',
    'saveCampaign',
    'reset'
].reduce(function (acc, type) {
    acc[type] = Event(type);
    return acc;
}, _manifest)

export default manifest;
